<template>
  <div class="cloud-resource">
    <div class="main">
      <!-- 左边导航 -->
      <div class="nav-bar">
        <NavBarList @selectOption='selectOption' />
      </div>

      <!-- 右边展示内容 -->
      <div class="main-view">
        <!-- 内容顶部类型导航 -->
        <div class="type-nav">
          <TypeNav @typeObj='typeObj' />
        </div>

        <!-- 内容展示 -->
        <div class="content-list">
          <ResourceList :loading='loading' v-loading="loading" element-loading-spinner="el-icon-loading"
            element-loading-text="拼命加载中" :amCloudResource='amCloudResource' />

          <!-- 页码 -->
          <div class="page-num">
            <PageNum :pageTotal='pageTotal' :currentPage1.sync='currentPage' />
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
//API--------------------------------------------
import { selectPaper } from "@/network/resourceRequest/api";

//左边导航
import NavBarList from "@/views/paperCenter/components/volumeLibrary/components/NavBarList";
//顶部导航
import TypeNav from "@/views/paperCenter/components/volumeLibrary/components/TypeNav";

//内容展示--------------------------------------------
import ResourceList from "@/views/paperCenter/components/volumeLibrary/components/ResourceList";
//页码导航--------------------------------------------
import PageNum from "@/components/common/PageNum";

export default {
  name: "VolumeLibrary",
  components: {
    NavBarList,
    TypeNav,
    ResourceList,
    PageNum
  },
  data() {
    return {
      //筛选的条件
      fd: {},

      //当前页码--------------------------------------------
      currentPage: 1,
      //页码总数量
      pageTotal: 0,

      //展示内容
      amCloudResource: {},

      //加载是否成功--------------------------------------------
      loading: false
    };
  },

  watch: {
    //页码筛选
    currentPage(newVal, oldVal) {
      this.fd.pageNum = newVal;
      this.getSelectResource(this.fd, "pageNum");
    }
  },

  methods: {
    //侧边筛选数据
    selectOption(option) {
      for (const key in option) {
        if (option.hasOwnProperty(key)) {
          const element = option[key];
          if (element == "全部") {
            delete this.fd[key];
            continue;
          } else {
            this.$set(this.fd, key, element);
          }
        }
      }
      this.getSelectResource(this.fd);
    },

    //类型筛选条件
    typeObj(e) {
      this.fd.year && delete this.fd.year;
      this.fd.ptype && delete this.fd.ptype;
      this.fd.area && delete this.fd.area;
      for (const key in e) {
        if (e.hasOwnProperty(key)) {
          if (e[key] == "全部") {
            delete this.fd[key];
          } else {
            const element = e[key];
            this.$set(this.fd, key, element);
          }
        }
      }

      this.getSelectResource(this.fd);
    },

    //根据条件获取数据
    getSelectResource(fd, type) {
      if (type != "pageNum") {
        this.fd.pageNum = 1;
        this.currentPage = 1;
      }

      //进行任何非页码筛选均改回第一页
      this.fd.pageSize = 10;
      this.loading = true;
      selectPaper(fd).then(res => {
        if (res.data.success) {
          this.loading = false;
          this.amCloudResource = res.data.data ? res.data.data : {};
          this.pageTotal = res.data.data ? Number(res.data.data.total) : 0;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.cloud-resource {
  padding-top: 5px;

  .main {
    display: flex;

    margin: 0 auto;
    width: 1200px;
    min-height: 1200px;

    justify-content: space-between;

    // 左边导航
    .nav-bar {
      border-radius: 5px;
      padding: 0 20px;
      width: 235px;
      min-height: 500px;

      background-color: #fff;

      box-shadow: 0 0 5px 1px #ccc;
    }

    //内容
    .main-view {
      overflow: hidden;

      border-radius: 5px;
      width: 960px;
      min-height: 500px;

      background-color: #fff;

      box-shadow: 0 0 5px 1px #ccc;

      .type-nav {
        display: flex;

        position: relative;

        border-bottom: 1px solid rgba(229, 229, 229, 1);
        padding-left: 20px;
        height: 60px;

        align-items: flex-end;
      }

      .content-list {
        /deep/ .el-loading-spinner {
          top: 0 !important;
        }

        /deep/ .el-loading-spinner i {
          color: #24ba58 !important;
        }

        /deep/ .el-loading-spinner .el-loading-text {
          color: #24ba58 !important;
        }
        .page-num {
          display: flex;

          margin: 20px 0;

          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>